import { events, track } from 'src/analytics';

export function trackPostCheckoutDoYouLoveDogs(direction: 'left' | 'right') {
  return track(events.post_checkout_dyld, {
    action: 'Do you love dogs?',
    label: direction,
  });
}
